// extracted by mini-css-extract-plugin
export default {"subHeader":"MinorNav-module--subHeader--11ade"};